import actions from '../../actionTypes';

export default id => {
  return {
    type: actions.EXPAND_COLLAPSE_TAG,
    id
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/expandTag.js